export default __webpack_public_path__ + "static/media/footer.b7ded854.webp";